const WS_URL = 'wss://app.biel.ai/ws/messages';

export class BielWebSocketService {
  private ws: WebSocket;
  private messageHandlers: ((message: any) => void)[] = [];
  private isConnected: boolean = false;
  private projectId: string;
  private chatId: string = '';
  private email: string = '';
  private errorMessage: string;
  private loadingStartHandler: () => void;
  private loadingEndHandler: () => void;

  constructor(projectId: string, errorMessage: string, email: string) {
    this.projectId = projectId;
    this.errorMessage = errorMessage;
    this.email = email;
    this.connect();
  }

  private connect(): void {
    this.ws = new WebSocket(`${WS_URL}/${this.projectId}/`);

    this.ws.onopen = () => {
      this.isConnected = true;
    };

    this.ws.onmessage = (event) => {
      const message = JSON.parse(event.data);
      if (!this.chatId && message.chatId) {
        this.chatId = message.chatId;
      }
      if (message.from) {
        this.loadingEndHandler();
        this.messageHandlers.forEach((handler) => handler(message));
      }
    };

    this.ws.onclose = () => {
      this.isConnected = false;
    };

    this.ws.onerror = (error) => {
      console.error('WebSocket error:', error);
      this.isConnected = false;
      this.loadingEndHandler();
    };
  }

  public sendMessage(message: string): void {
    const payload = {
      projectId: this.projectId,
      chatId: this.chatId,
      url: window.location.href,
      email: this.email,
      from: 'user',
      message: message,
    };
    if (this.isConnected) {
      this.ws.send(JSON.stringify(payload));
      this.loadingStartHandler();
    } else {
      this.messageHandlers.forEach((handler) =>
        handler({ message: this.errorMessage, from: 'ai' })
      );
    }
  }

  public closeSocket(): void {
    this.ws.close();
  }

  public onMessage(handler: (message: any) => void): void {
    this.messageHandlers.push(handler);
  }

  public onLoadingStart(handler: () => void): void {
    this.loadingStartHandler = handler;
  }

  public onLoadingEnd(handler: () => void): void {
    this.loadingEndHandler = handler;
  }
}
